module.exports = __webpack_public_path__ + "img/Detached_House.00076824.svg";